import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  profileDetails: null,
};

const uiSlice = createSlice({
  name: "uiSlice", // name of the slice
  initialState: initialState, // initial state of the slice
  reducers: {
    setProfileDetails: (state, action) => {
      state.profileDetails = action.payload;
    },
  },
});

export const assoProfileDetails = uiSlice.actions;
export default uiSlice.reducer;
